import React, { useEffect } from 'react';

import Footer from 'components/Additional/Footer/Footer';
import Navigation from '../Overlays/Navigation';
import { createActivityQuoteDB } from '../API/Model';

import 'components/styles/styles.css';
import './ThankYou_page.css';

function ThankYou_page() {
	const page = 5;
	const PAGE_NAME = 'ThankYou';

	useEffect(() => {
		createActivityQuoteDB(PAGE_NAME, 'PL', 'ThankYou page loaded');
	}, []);

	return (
		<div className="base-wrapper">
			<div className="abs-wrapper">
				<Navigation page={page} progress={4} hide={true} />
			</div>
			<div className="coverages-content-wrapper">
				<div className="wrapper" id="content">
					<p className="text-3xl text-center">
						Thank you for your interest!
					</p>
					<p
						className=""
						style={{ fontSize: 20, textAlign: 'center' }}
					>
						Our Florida-based team will contact you within the next
						24 hours (Monday-Friday).
					</p>
					<div className="p6_footer">
						<a
							className="btn_container"
							href="https://www.securityfirstflorida.com"
						>
							<button type="submit" className="btn_p7">
								Learn more about Security First Insurance
							</button>
						</a>
					</div>
				</div>
				<Footer />
			</div>
		</div>
	);
}

export default ThankYou_page;
